import { Form, Input, Table, Tag } from "antd";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { getCurrentUser } from "../redux/actions/user";
import { getCurrentUserOrder } from "../redux/actions/orders";
import { logout, signin } from "../redux/actions/auth";
import { updateUser } from "../redux/actions/user";
import { formatDate } from "../utils/Utils";
import { store } from "../api/index";
import Breadcrumb from "../components/Breadcrumb";

const Account = ({ currentUser, storeCurrency }) => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const [form] = Form.useForm();
  const orders = useSelector((state) => state.orders);
  const user = useSelector((state) => state.currentUser);

  const onFinish = (formData) => {
    dispatch(updateUser(currentUser.id, formData));
  };

  const onFinishSignIn = (value) => {
    let formData = {
      ...value,
      store,
    };
    dispatch(signin(formData));
  };

  useEffect(() => {
    if (currentUser) {
      dispatch(getCurrentUser(currentUser.id));
      dispatch(getCurrentUserOrder(currentUser.id));
    }
  }, [currentUser, dispatch]);

  useEffect(() => {
    form.setFieldsValue({
      name: user?.name,
      phone: user?.phone,
    });
  }, [currentUser, user?.name, user?.phone, form]);

  const logoutUser = () => {
    dispatch(logout());
    history("/");
  };

  const columns = [
    {
      title: "Order ID",
      dataIndex: "_id",
      key: "_id",
    },
    {
      title: "Order Date",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (record) => `${formatDate(record)}`,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (record) => (
        <>
          <Tag color={`${record === "Completed" ? "green" : "geekblue"}`}>
            {record}
          </Tag>
        </>
      ),
    },
    {
      title: "Payment Method",
      dataIndex: "paymentMethod",
      key: "paymentMethod",
    },
    {
      title: "Total Price",
      dataIndex: "totalPrice",
      render: (record) => `${storeCurrency} ${record}`,
    },
    // {
    //   title: "Action",
    //   key: "action",
    //   render: (_, record) => (
    //     <Space size="middle">
    //       <Link>Track Order{record.name}</Link>
    //     </Space>
    //   ),
    // },
  ];

  return (
    <div>
      <Breadcrumb heading={"Sign In"} />
      <div className="container mx-auto">
        {!currentUser ? (
          //Sign In Screen
          <div className="login_part container mx-auto my-20">
            <div className="md:grid grid-cols-2 gap-20">
              <div className="login_part_text text-center py-20 px-10">
                <h2>New to our Shop?</h2>
                <p>
                  There are advances being made in science and technology
                  everyday, and a good example of this is the
                </p>
                <div className="flex justify-center items-center">
                  <Link to="/register" className="btn_white">
                    Create an Account
                  </Link>
                </div>
              </div>
              <div className="login_part_form p-4">
                <h3>
                  Welcome Back ! <br />
                  Please Sign in now
                </h3>
                <Form
                  form={form}
                  name="basic"
                  onFinish={onFinishSignIn}
                  requiredMark={false}
                  layout="vertical"
                  autoComplete="off"
                >
                  <Form.Item
                    label="Email"
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your username!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    label="Password"
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your password!",
                      },
                    ]}
                  >
                    <Input.Password />
                  </Form.Item>

                  <button type="submit" className="info__button">
                    Log In
                  </button>
                </Form>
              </div>
            </div>
          </div>
        ) : (
          //User account Screen
          <div className="login_part container mx-auto my-20">
            <div className="md:grid grid-cols-2 gap-20">
              <div className="login_part_text text-center py-20 px-10">
                <h2>View Order & Profile</h2>
                <p>
                  There are advances being made in science and technology
                  everyday, and a good example of this is the
                </p>
              </div>
              <div className="login_part_form p-4">
                <h3>Welcome! {currentUser?.name}</h3>
                <Form
                  layout="vertical"
                  onFinish={onFinish}
                  requiredMark={false}
                  form={form}
                  autoComplete="off"
                >
                  <Form.Item
                    label="Name"
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Please input user name!",
                      },
                    ]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item label="Phone" name="phone">
                    <Input type="number" />
                  </Form.Item>
                  <div className="flex justify-start gap-4">
                    <button type="submit" className="info__button">
                      Update
                    </button>
                    <button className="info__button" onClick={logoutUser}>
                      Logout
                    </button>
                  </div>
                </Form>
              </div>
            </div>
            <div className="p-4">
              <h2 className="heading_h2 text-center my-20">Recent Orders</h2>
              {orders?.length > 0 ? (
                <Table
                  rowKey={(record) => record._id}
                  columns={columns}
                  dataSource={orders}
                  scroll={{
                    x: 800,
                  }}
                />
              ) : (
                "You have no order!"
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Account;
